import { render, staticRenderFns } from "./MultipleParticipantsConfig.vue?vue&type=template&id=4a115548&scoped=true&"
import script from "./MultipleParticipantsConfig.vue?vue&type=script&lang=js&"
export * from "./MultipleParticipantsConfig.vue?vue&type=script&lang=js&"
import style0 from "./MultipleParticipantsConfig.vue?vue&type=style&index=0&id=4a115548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a115548",
  null
  
)

export default component.exports